<template>
    <kt-panel>
        <div class="accordion accordion-toggle-arrow" id="tax_filter">
            <div class="card" style="overflow:inherit">
                <div class="card-header bg-transparent" id="headingOne">
                    <div class="card-title collapsed" data-toggle="collapse"
                         data-target="#filterForm"
                         aria-controls="filterForm">
                        {{ $t('reports.tax.newExport') }}
                    </div>
                </div>
                <div id="filterForm" class="collapse" aria-labelledby="filterForm" data-parent="#tax_filter">
                    <div class="card-body">
                        <form id="tax_export_form" @submit.prevent="exportExcel">
                            <kt-form-section>
                                <kt-form-row>
                                    <kt-col xs="12" sm="6" md="6">
                                        <kt-form-group>
                                            <kt-form-label for="from_date">
                                                {{ $t('reports.tax.from_date') }}
                                            </kt-form-label>
                                            <button id="reset_from_date"
                                                    @click="clearFromDate"
                                                    class=" btn btn-label-danger trash-btn"
                                            >
                                                <i class="la la-trash-o"></i>
                                            </button>
                                            <datePicker
                                                    format="YYYY-MM-DD HH:mm:ss"
                                                    display-format="dddd jDD jMMMM jYYYY"
                                                    input-class="form-control"
                                                    id="from_date"
                                                    name= "from_date"
                                                    v-model="query.from_date"
                                                    type="date" />
                                        </kt-form-group>
                                    </kt-col>
                                    <kt-col xs="12" sm="6" md="6">
                                            <kt-form-group>
                                                <kt-form-label for="to_date">
                                                    {{ $t('reports.tax.to_date') }}
                                                </kt-form-label>
                                                <button id="reset_to_date"
                                                        @click="clearToDate"
                                                        class=" btn btn-label-danger trash-btn"
                                                >
                                                    <i class="la la-trash-o"></i>
                                                </button>
                                                <datePicker
                                                        format="YYYY-MM-DD HH:mm:ss"
                                                        display-format="dddd jDD jMMMM jYYYY"
                                                        input-class="form-control"
                                                        id="to_date"
                                                        name= "to_date"
                                                        v-model="query.to_date"
                                                        type="date"
                                                />
                                            </kt-form-group>
                                        </kt-col>
                                    </kt-form-row>
                            </kt-form-section>
                            <kt-form-section>
                                <kt-row>
                                    <kt-col xs="12" sm="12" md="12">
                                        <kt-button
                                                class="btn btn-success btn-wide float-right"
                                                size="md"
                                                variant="success"
                                                type="submit"
                                                id="tax_export_btn"
                                                @click="exportExcel($event, query)"
                                        >
                                            {{ $t('reports.btn.export_tax_to_excel') }}
                                        </kt-button>
                                    </kt-col>
                                </kt-row>
                            </kt-form-section>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </kt-panel>
</template>

<script>

import $ from "jquery";
import { i18n } from '@/plugins/i18n'

export default {
        props: {
            exportExcel: {
                default: function(e, query) {},
                required: true,
            }
        },
        data() {
            return {
                query: {}
            }
        },
        methods: {
            clearFromDate() {
                if(this.query.from_date) {
                    this.query.from_date = null
                }
            },
            clearToDate() {
                if(this.query.to_date) {
                    this.query.to_date = null
                }
            },
            afterDispatch() {
                $('.kt-selectpicker').selectpicker({
                    size: 4,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_selected')
                })
            },
        },
        mounted() {
            this.afterDispatch()
        },
}
</script>

<style>

</style>